import { render } from "./Game.vue?vue&type=template&id=5c25735e"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=5c25735e&scss=true&lang=css"

import exportComponent from "E:\\project2\\skin-web\\破阵勇士\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__